import Skeleton from 'react-loading-skeleton';
import { appStore } from '~/mobx/appStore';
import { localeStore } from '~/mobx/localesStore';
import client from '~/services/client';
import logger from '~/services/logger';
import { TBooleanInNumber } from '~/types/main';
import { toastError, toastSuccess } from '~/utils/toasts';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';

const SimplifiedTimeControl = () => {
  const handleToggleChange = async (status: TBooleanInNumber) => {
    try {
      await client.patch('v3/app/settings', { simplified_working_hours: status });
      toastSuccess({
        message: localeStore.t(status ? 'toast_wh_simplified_view_toggle_on' : 'toast_wh_simplified_view_toggle_off'),
      });
    } catch (error: any) {
      logger.error({ error, place: 'SimplifiedTimeControl handleToggleChange' });
      toastError({ message: error.message });
    }
  };

  return (
    <div className="d-flex align-items-center radius-16 bg-graysoft p-4" style={{ visibility: 'hidden' }}>
      <Switcher status={appStore.settings?.simplified_working_hours || 0} onChange={handleToggleChange} />
      <p className="family-medium text-size-18 ml-4">{localeStore.t('wh_simplified_view_toggle')}</p>
      <TooltipIcon message="wh_simplified_view_toggle_hint" iconSize={18} maxWidth={330} minWidth={330} wrapperClassName="ml-2" />
    </div>
  );
};

export default SimplifiedTimeControl;
